import { render, staticRenderFns } from "./SalesListFunc.vue?vue&type=template&id=559f510c&scoped=true"
import script from "./SalesListFunc.vue?vue&type=script&lang=js"
export * from "./SalesListFunc.vue?vue&type=script&lang=js"
import style0 from "./SalesListFunc.vue?vue&type=style&index=0&id=559f510c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f510c",
  null
  
)

export default component.exports